import OfferImg from '../../assets/img/offer.png';

export const CategoryCard = ({category, handleClick}) => {
  const isDisabled = category.disabled;
  const hasOffers = Boolean(category.offers);

  const onClickHandler = () => {
    handleClick(category)
  }

  return (
    <div
      className={`
    rounded-[8px] ${!isDisabled ? 'shadow-md transition-all duration-300 sm:hover:shadow-lg sm:hover:scale-105' : ''}
    flex flex-col items-start h-[120px] w-full relative
    ${isDisabled ? 'bg-white' : 'bg-white hover:bg-gray-50 cursor-pointer'}
  `}
      onClick={onClickHandler}

    >
      {hasOffers && (
        <div className="absolute top-3 right-0 flex flex-col items-end">
          <div className="flex items-center">
            <img src={OfferImg} className='h-[30px] w-[30px] xs:h-[38px] xs:w-[38px] sm:h-[40px] sm:w-[40px] z-10 mr-[-10px] mt-[-10px]'/>
            <div className="bg-[#FF9700] text-white px-1 sm:px-2 py-0.5 text-[10px] xs:text-xs sm:text-sm font-bold tracking-wide whitespace-nowrap overflow-hidden text-ellipsis max-w-[80px] xs:max-w-[100px] sm:max-w-[120px]">
              PROMOȚII
            </div>
          </div>
        </div>
      )}

      <div className="flex flex-col h-full w-full p-4">
        <div className="flex items-start justify-between w-full">
          <div className="text-3xl">
            {category.icon && <img src={category.icon} className={'h-12 w-12'} />}
          </div>
        </div>

        <div
          className={`
            font-onest font-medium text-lg leading-[100%] mt-auto text-left
            ${isDisabled ? 'text-gray-400' : 'text-gray-800'}
          `}
        >
          {category.name}
        </div>
      </div>
    </div>
  );
};